import { supabase } from './supabaseClient';
import type { Product, RoutineSet } from '@/types/product';
import { IMAGES } from '@/constants/images';
import { registerProductSlugs } from './coreOrder';
import { fetchCatalog } from '@/shared/rxk-product/catalog';

// The storefront catalog. The mapping itself lives in the shared product
// module (src/shared/rxk-product/catalog.ts), which Pick.K Seoul uses too.
export type { ProductContentRow } from '@/shared/rxk-product/catalog';

export async function fetchProducts(): Promise<{ products: Product[]; routineSet: RoutineSet | null; setProduct: Product | null }> {
  const { products, routineSet, setProduct, contentRows } = await fetchCatalog(supabase, IMAGES.threeStepSet);
  registerProductSlugs(contentRows);
  return { products, routineSet, setProduct };
}
